import { computed as l, resolveComponent as o, openBlock as d, createBlock as _, withCtx as e, createVNode as r, createTextVNode as s, renderSlot as f, toDisplayString as u } from "vue";
/* empty css                    */
import D from "./design-system.es128.js";
import g from "./design-system.es37.js";
/* empty css                    */
import x from "./design-system.es94.js";
import S from "./design-system.es95.js";
import b from "./design-system.es106.js";
/* empty css                    */
/* empty css                    */
import k from "./design-system.es116.js";
const B = {
  name: "DsMenuLoading",
  components: {
    DsSpinner: S,
    DsBox: g,
    DsStack: x,
    DsText: b
  },
  setup() {
    const t = k();
    return {
      label: l(() => t.t("menu.loading"))
    };
  }
};
function T(t, n, $, p, v, y) {
  const i = o("DsSpinner"), a = o("DsText"), c = o("DsStack"), m = o("DsBox");
  return d(), _(m, {
    "padding-top": "spacing-500",
    "padding-bottom": "spacing-400",
    class: "ds-menu-loading"
  }, {
    default: e(() => [
      r(c, {
        space: "spacing-200",
        "align-x": "center"
      }, {
        default: e(() => [
          r(i, { size: 48 }),
          n[0] || (n[0] = s()),
          f(t.$slots, "label", {}, () => [
            r(a, { variant: "body" }, {
              default: e(() => [
                s(u(p.label), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  });
}
const A = /* @__PURE__ */ D(B, [["render", T]]);
export {
  A as default
};
//# sourceMappingURL=design-system.es76.js.map
